import { render, staticRenderFns } from "./validate-0ABJ.vue?vue&type=template&id=54281cc4"
import script from "./validate-0ABJ.vue?vue&type=script&lang=js"
export * from "./validate-0ABJ.vue?vue&type=script&lang=js"
import style0 from "./validate-0ABJ.vue?vue&type=style&index=0&id=54281cc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports